module.exports = __webpack_public_path__ + "img/logo1.c37d3536.png";